<template>
  <div class="checkbox checkbox-new-custom" role="group" :aria-labelledby="id+'_label'">
    <label :for="id + '-' + idx" v-for="(option,idx) in optionsAll" :key="idx" :class="innerClass" class="customCbLabel">
      <input :name="id" :id="id + '-' + idx" type="checkbox" v-model="checked" :value="option.value" @click.capture="checkAllowEmpty($event)" @change="triggerEvent(option)" >

      <span class="checkbox-custom-btn"></span>
      {{option.name}}
      <span v-if="aria">{{aria}}</span>
    </label>
  </div>
</template>

<script>
import map from "lodash/map";
import filter from "lodash/filter";

const _ = { map, filter };
export default {
  name: "IcCheckboxGroup",
  props: {
    id: { type: String, required: true },
    value: { required: true },
    aria: { type: String, required: false },
    options: { type: Array, required: true },
    asObject: { type: Boolean, default: false },
    allowEmpty: { type: Boolean, default: true },
    innerClass: { type: [String, Object], default: "" },
    any: { type: [Boolean], default: false },
    anyName: { type: String, default: "Dowolne" }
  },
  data() {
    return {
      checked: [] //checked
    };
  },
  created() {
    this.values = typeof this.value == "object" ? this.value : [this.value];
  },
  computed: {
    values: {
      set: function(v) {
        this.checked = _.map(v, val => (this.asObject ? val.id : val));
      },
      get: function() {
        let ret = _.filter(
          _.map(this.options, v =>
            this.checked.indexOf(v.id) != -1
              ? this.asObject
                ? v
                : v.id
              : false
          ),
          v => v
        );
        return ret;
      }
    },
    optionsAll: function() {
      return this.any === true && this.options[0].id !== ""
        ? [{ id: "", name: this.anyName }, ...this.options]
        : this.options;
    }
  },
  methods: {
    checkAllowEmpty(e){
      if(this.checked.length == 1 && e.target.checked === false && this.allowEmpty == false) e.preventDefault();
      

    },
      triggerEvent(event) {
        
        if(this.options.map(function(x) {return x.value; }).indexOf("na") !== -1){
          if(event.value == "na") this.checked = ["na"];
          else if(this.checked.indexOf("na") !== -1){
            this.checked = this.checked.filter((a)=>a !== 'na');
          }
        }
        this.$emit("input", this.checked);
        this.$emit("update:select", event.value);
        if (this.v) {
          this.v.$touch()
        }        
      }
  },
  watch: {

    checked: function(newValue, oldValue) {
      if (newValue != oldValue) {
      //  this.values = newValue;
      }


    },

    // values: function(newValue, oldValue) {
    //   //console.log(newValue,oldValue);
    //   if (newValue !== oldValue) {
    //     let v = newValue;
    //     if (this.options.length > 1) {
    //       this.$emit("input", v);
    //     } else {
    //       this.$emit("input", v[0] ? v[0] : null);
    //     }
    //   }
    // }
  }
};
</script>
 
<style lang="css">

.customCbLabel{
  display:block;
  position:relative;
  padding-left:30px;
}
</style>
